module.exports = __webpack_public_path__ + "img/ifs_en.52ffa016.png";